export default __webpack_public_path__ + "static/media/whatsapp.4c40a136.png";